import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryCards() {
  return (
    <section className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
          视频分类
        </h2>
        <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
          涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，满足你的所有观影需求
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative bg-white rounded-xl border border-gray-100 p-5 md:p-6 text-center hover:border-amber-200 transition-all duration-300 cursor-pointer hover:-translate-y-1"
          >
            <div
              className={`w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-xl flex items-center justify-center ${cat.color} text-white`}
            >
              <i className={`${cat.icon} text-xl md:text-2xl`}></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-gray-800 mb-1 whitespace-nowrap">
              {cat.name}
            </h3>
            <p className="text-xs text-gray-400 hidden md:block">
              {cat.description}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}